<div class="error" *ngFor="let errorKey of errorsKeys">
    <span *ngIf="control?.hasError(errorKey?.error)">{{errorMessage(errorKey)}}</span>
</div>
